import React from "react";
import { ButtonGroup } from "@chakra-ui/react";
import RelatedContentButton from "../../Content/components/RelatedContentButton";
import KnowledgeCardButton from "../../Content/components/KnowledgeCardButton";
import DeleteButton from "../../Content/components/DeleteButton";
import MoveButton from "../../Content/components/MoveButton";
import UploadFile from "../../Content/components/UploadFile";
import { ContentAttachment } from "../../../common/types";
import { IconButton, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SizeAwareComponent } from "../../../store/types";


interface OwnProps {
    onAttachmentUploaded: (a: ContentAttachment) => void;
    onLinkContent: () => void;
}

export const ContentActionsButtons = ({ onAttachmentUploaded, onLinkContent }: OwnProps) => {
    return (
        <ButtonGroup
            spacing={2}
            size={"sm"}
        >
            <RelatedContentButton onLinkContent={onLinkContent} />
            <KnowledgeCardButton />
            <UploadFile onAttachmentUploaded={onAttachmentUploaded} />
            <MoveButton />
            <DeleteButton />
        </ButtonGroup>

    );
};
export const ActionsMenu = ({ isMinimumSize }: SizeAwareComponent) => {
    return <Menu variant="outline">
        <MenuButton
            as={IconButton}
            icon={<FontAwesomeIcon icon={faGear} />}
            variant={isMinimumSize ? "outline" : "ghost"}
            padding={isMinimumSize ? undefined : 0}
            margin={isMinimumSize ? undefined : 0}
            minWidth={isMinimumSize ? undefined : "5"}
        />
        <MenuList>
            {/* <RelatedContentButton onLinkContent={onLinkContent} mode="menu-item"/>
            <KnowledgeMenuItem />
            <UploadFile onAttachmentUploaded={onAttachmentUploaded} mode="menu-item" /> */}
            <MoveButton mode="menu-item" />
            <DeleteButton mode="menu-item" />
        </MenuList>
    </Menu>;
};